import { InvoiceItemModel } from "types/generated/models";
import { useSnackbar } from "@powerdiary/components-library/lib";
import { useClientPortalConfigContext } from "context/ClientPortalConfig.ctx";
import { useQueryClient } from "@tanstack/react-query";
import { Box, Button } from "@mui/material";
import InvoiceStripePaymentShared from "../../Shared/StripePayment/InvoiceStripePaymentShared";

interface IInvoiceViewStripePayment {
    invoice: InvoiceItemModel;
    handleClose: () => void;
}

const FORM_ID = "invoice-view-stripe-payment-form";

export default function InvoiceViewStripePayment({ invoice, handleClose }: IInvoiceViewStripePayment) {
    const { enqueueSnackbar } = useSnackbar();
    const { clientPortalGuid, clientPortalConfig } = useClientPortalConfigContext();
    const queryClient = useQueryClient();

    const handleSuccessfulPayment = async () => {
        await queryClient.invalidateQueries({
            predicate: (query) =>
                typeof query.queryKey[0] === "string" &&
                query.queryKey[0].startsWith(`/api/v1/${clientPortalGuid}/Invoices/ViewInvoice`),
        });

        handleClose();
        enqueueSnackbar("Payment successful!", { variant: "success" });
    };
    return (
        <Box data-test-id="invoices_view_stripe_payment" sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            <InvoiceStripePaymentShared
                {...invoice}
                invoiceIds={[invoice.id]}
                practitionerId={invoice.practitioner?.practitionerId}
                amount={invoice.amountOwingDecimal}
                clientId={clientPortalConfig?.userLoggedIn ? undefined : invoice.clientId}
                formId={FORM_ID}
                onSuccessfulPayment={() => void handleSuccessfulPayment()}
            />
            <Button
                variant="contained"
                type="submit"
                size="large"
                form={FORM_ID}
                fullWidth
                data-test-id="button_pay_now"
            >
                Pay Now
            </Button>
        </Box>
    );
}
